import React from "react";
import useDimensions from "react-cool-dimensions";

const withContainerDimensions =
  ({ key, widthAdjustment, text }) =>
  (Component) =>
  (props) => {
    const { observe, width } = useDimensions();        
    return (
      <div key={key} ref={observe}>
        <Component width={width - widthAdjustment} {...props}>
          <div key={key}>
            {text}
          </div>
        </Component>
      </div>
    );
  };

export default withContainerDimensions;
